class SingleLand {
    constructor() {

        this.singleLand = document.body.classList.contains('single-land');
        if( !this.singleLand ){
            return;
        }
        this.loadMap();
        this.buildGallery();
        this.buildSwiperGallery();
        this.buildSwiperLandRelated();

        ScrollTrigger.create({
            trigger : '.single-land-form',
            start: "top center",
            end: "bottom top",
            toggleClass: {targets: ".cta-scrollto-form", className: "hide"}
        });

        document.querySelector('.cta-scrollto-form').addEventListener('click', () => {
            window.scrollTo({
                top: document.querySelector('.single-land-form').offsetTop - document.querySelector('.header-main').offsetHeight,
                behavior: "smooth"
            });
        });

    }

    loadMap() {
        this.bounds = new google.maps.LatLngBounds();
        this.places = document.querySelector('.map-marker');
        this.mapView = document.querySelector('.single-land-map');
        this.markers = [];

        console.log(this.places.dataset.lat);

        let centerMap = new google.maps.LatLng(this.places.dataset.lat, this.places.dataset.lng);

        this.map = new google.maps.Map(this.mapView, {
            center: centerMap,
            zoom: 10,
            clickableIcons: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            zoomControl: false,
            gestureHandling: "cooperative",
            mapId: "6ff68edf5d1d30ef"
        });

        let marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            zIndex: 0,
            content: this.places.querySelector('.map-marker-inner'),
            position: {
                lat: parseFloat(this.places.dataset.lat),
                lng: parseFloat(this.places.dataset.lng)
            }
        });

    }

    buildSwiperGallery() {
        this.prevArrow = document.querySelector('.galerie .prev-btn');
        this.nextArrow = document.querySelector('.galerie .next-btn');
        const singleSwiper = new Swiper(".single-swiper", {
            slidesPerView: 'auto',
            spaceBetween: 30,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },
                990: {
                    slidesPerView: 2,
                    spaceBetween: 80,
                },
                2000: {
                    slidesPerView: 3,
                    spaceBetween: 80,
                }
            },

            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
                clickable: true,
            }
        });
    }

    buildGallery() {
        lightGallery(document.querySelector('.galerie .swiper-wrapper'), {
            speed: 500,
            selector: "a",
            zoomFromOrigin: false,
            licenseKey: '0000-0000-000-0001',
            getCaptionFromTitleOrAlt: true,
        });
    }

    buildSwiperLandRelated() {
        this.prevArrow = document.querySelector('.land_related .prev-btn');
        this.nextArrow = document.querySelector('.land_related .next-btn');
        const singleSwiper = new Swiper(".land_related_swiper", {
            slidesPerView: 'auto',
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                }
            },

            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
                clickable: true,
            }
        });
    }

}